document.addEventListener("DOMContentLoaded", () => {
    // Sticky Header
    const header = document.getElementById("main-header");
    const scrollThreshold = 50; // Pixels to scroll before header becomes sticky

    window.addEventListener("scroll", () => {
        if (window.scrollY > scrollThreshold) {
            header.classList.add("scrolled");
        } else {
            header.classList.remove("scrolled");
        }
    });

    // Smooth Scrolling for Nav Links
    document.querySelectorAll("nav a[href^=\"#\"]").forEach(anchor => {
        anchor.addEventListener("click", function (e) {
            e.preventDefault();
            const targetId = this.getAttribute("href");
            const targetElement = document.querySelector(targetId);
            if (targetElement) {
                let headerOffset = 0;
                if (header.classList.contains("scrolled")) {
                    headerOffset = header.offsetHeight;
                }
                const elementPosition = targetElement.getBoundingClientRect().top;
                const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

                window.scrollTo({
                    top: offsetPosition,
                    behavior: "smooth"
                });

                document.querySelectorAll("nav a").forEach(link => link.classList.remove("active"));
                this.classList.add("active");
            }
        });
    });

    // --- Generic Carousel Function --- 
    function setupCarousel(containerSelector, carouselSelector, prevBtnSelector, nextBtnSelector, itemSelector) {
        const carouselContainer = document.querySelector(containerSelector);
        const carousel = carouselContainer?.querySelector(carouselSelector);
        const prevButton = carouselContainer?.querySelector(prevBtnSelector);
        const nextButton = carouselContainer?.querySelector(nextBtnSelector);
        const items = carousel?.querySelectorAll(itemSelector);

        if (!carousel || !prevButton || !nextButton || !items || items.length === 0) {
            // console.warn(`Carousel setup failed for: ${containerSelector}`);
            return; // Exit if essential elements are missing
        }

        let itemWidth = items[0].offsetWidth;
        let gap = parseInt(window.getComputedStyle(carousel).gap) || 30;
        let scrollAmount = itemWidth + gap;
        let currentIndex = 0;
        const totalItems = items.length;
        let itemsInView = Math.floor(carouselContainer.offsetWidth / scrollAmount) || 1; // Ensure at least 1
        let maxIndex = totalItems - itemsInView;
        if (maxIndex < 0) maxIndex = 0; // Handle case where all items fit

        const updateCarouselPosition = () => {
            itemWidth = items[0].offsetWidth; // Recalculate width
            gap = parseInt(window.getComputedStyle(carousel).gap) || 30;
            scrollAmount = itemWidth + gap;
            itemsInView = Math.floor(carouselContainer.offsetWidth / scrollAmount) || 1;
            maxIndex = totalItems - itemsInView;
            if (maxIndex < 0) maxIndex = 0;
            // Adjust currentIndex if it becomes invalid after resize
            if (currentIndex > maxIndex) {
                currentIndex = maxIndex;
            }
            
            const offset = -currentIndex * scrollAmount;
            carousel.style.transform = `translateX(${offset}px)`;
            updateArrowVisibility();
        };

        const updateArrowVisibility = () => {
            prevButton.style.display = currentIndex > 0 ? "flex" : "none";
            nextButton.style.display = currentIndex < maxIndex ? "flex" : "none";
        };

        nextButton.addEventListener("click", () => {
            if (currentIndex < maxIndex) {
                currentIndex++;
                updateCarouselPosition();
            }
        });

        prevButton.addEventListener("click", () => {
            if (currentIndex > 0) {
                currentIndex--;
                updateCarouselPosition();
            }
        });

        // Initial setup
        updateCarouselPosition();

        // Recalculate on resize
        let resizeTimeout;
        window.addEventListener("resize", () => {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(updateCarouselPosition, 250); // Debounce resize
        });
    }

    // --- Initialize Carousels --- 
    setupCarousel(
        ".integrate-carousel-container", 
        ".integrate-carousel", 
        ".integrate-prev", 
        ".integrate-next", 
        ".integrate-item"
    );

    setupCarousel(
        ".agent-carousel-container", 
        ".agent-carousel", 
        ".agent-prev", 
        ".agent-next", 
        ".agent-card-horizontal"
    );

    // --- Contact Form Modal Logic (Moved inside DOMContentLoaded) ---
    const modal = document.getElementById("contact-modal");
    const btn = document.getElementById("request-demo-btn"); 
    const span = document.getElementsByClassName("close-button")[0];

    // Function to open the modal
    function openModal() {
      if(modal) modal.style.display = "block";
    }

    // Function to close the modal
    function closeModal() {
      if(modal) modal.style.display = "none";
    }

    // When the user clicks the button, open the modal 
    if (btn) {
      btn.onclick = function(event) {
        event.preventDefault(); // Prevent default anchor behavior
        openModal();
      }
    }

    // When the user clicks on <span> (x), close the modal
    if (span) {
      span.onclick = closeModal;
    }

    // When the user clicks anywhere outside of the modal, close it
    window.onclick = function(event) {
      if (event.target == modal) {
        closeModal();
      }
    }

    // Optional: Handle form submission (prevent default for now)
    const demoForm = document.getElementById("demo-request-form");
    if (demoForm) {
        demoForm.addEventListener("submit", function(event) {
            event.preventDefault();
            // Here you would typically send the form data via AJAX or similar
            alert("Thank you for your request! We will get back to you soon.");
            closeModal(); // Close modal after submission
        });
    }

}); // End of DOMContentLoaded




    // --- Mobile Menu Toggle --- 
    const hamburgerBtn = document.getElementById("hamburger-btn");
    const mobileNav = document.getElementById("mobile-nav");

    if (hamburgerBtn && mobileNav) {
        hamburgerBtn.addEventListener("click", () => {
            hamburgerBtn.classList.toggle("active");
            mobileNav.classList.toggle("active");
        });

        // Close mobile menu when a link is clicked
        mobileNav.querySelectorAll("a").forEach(link => {
            link.addEventListener("click", () => {
                hamburgerBtn.classList.remove("active");
                mobileNav.classList.remove("active");
            });
        });
    }

